import { BACKEND_API, PAY_API } from "global/environment";
import { postRequest } from "utils/http";

const baseURL = BACKEND_API;

export const PaymentService = {
  getListBank: function (data, successCallback, failCallback) {
    const URL = `${PAY_API}/banks.jsp?sandbox=release`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  paymentPackage: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/payment_package_reg_v2`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },
}